import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "font-family"
    }}>{`font-family`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`Sets the font family for a given element's text.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/font-family"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/font-family`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    font-family: Helvetica, Arial, 'Courier New';
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Does not support font families such as `}<inlineCode parentName="li">{`monospace`}</inlineCode>{`, `}<inlineCode parentName="li">{`serif`}</inlineCode>{` or `}<inlineCode parentName="li">{`sans-serif`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`If one font can't be located, fallback fonts will be tried until one is found. If none are found, the system font of the host application is used instead.`}</li>
      <li parentName="ul">{`By default, the font family used is the host's font. In general you should avoid specifying a font family if you're trying to get the default look and feel.`}</li>
      <li parentName="ul">{`Text edit fields do not support overriding the font family.`}</li>
      <li parentName="ul">{`Not all Spectrum UXP components support overriding the font family.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      